import type { UpdateBankTransferInput } from '@repo/api-contracts';
import { useRef, useState } from 'react';
import { useInvalidateMyOrders } from '@/entities/order';
import { useInvalidateBankTransfer } from '@/entities/payment';
import { useInvalidateBusinessProfile } from '@/entities/user';
import { trpc } from '@/shared/api';
export const useUpdateBankTransfer = () => {
  const mutation = trpc.payments.updateBankTransfer.useMutation();
  const orders = useInvalidateMyOrders();
  const invalidate = useInvalidateBankTransfer();
  const invalidateProfile = useInvalidateBusinessProfile();
  const flight = useRef<Promise<void> | null>(null);
  const [isPending, setPending] = useState(false);
  const update = (input: UpdateBankTransferInput): Promise<void> => {
    if (flight.current) return flight.current;
    setPending(true);
    const pending = (async () => {
      await mutation.mutateAsync(input);
      await Promise.all([
        invalidate(input.orderId),
        orders.detail(input.orderId),
        orders.list(),
        ...(input.taxInvoice?.saveToProfile ? [invalidateProfile()] : []),
      ]);
    })().finally(() => {
      flight.current = null;
      setPending(false);
    });
    flight.current = pending;
    return pending;
  };
  return { update, isPending };
};
